import { IRootState } from 'reducers';

const userVisibilitySettingsSelector = (state: IRootState) =>
  state.visibilitySettings.content?.setting.visibilitySettings ?? [];

export default userVisibilitySettingsSelector;
